import React, { useState } from "react";
import "./date-range-input.scss";
import DatePicker, { DateObject } from "react-multi-date-picker";

interface Props {
  onChange: (e:any) => void;
  startDate?: string;
  endDate?: string;
}
const DateRangeDropdown: React.FC<Props> = ({onChange, startDate, endDate}:Props) => {
  const [values, setValues] = useState([ startDate ? startDate: new DateObject(),endDate?endDate: new DateObject()]);
  const changeValue=(v:any)=>{
    setValues(v);
    onChange(v);
  }
  return (
    <div className="date-range-select">
      <DatePicker format="YYYY-MM-DD" value={values} onChange={changeValue} range />
    </div>
  );
};

export default DateRangeDropdown;
